import Phaser from 'phaser';
import WorkArea from '../WorkArea';
import SpritePool from '../../common/SpritePool';
import ToppingSprite from './ToppingSprite';
import ABCyaPhaser from '@abcya/abcya_phaser';
import SoundAssetKeys from '../../SoundAssetKeys';
import { checkPixelCollisionCanvas } from '../../ndgmr.Collision-phaser';

export default class ToppingsView extends Phaser.GameObjects.Container {
  /**
   * 
   * @param {Phaser.Scene} scene 
   * @param {WorkArea} workRef
   * @param {Phaser.GameObjects.Container} myContainer
   */
  constructor(scene, workRef, myContainer, infoRef) {
    super(scene);

    this.workRef = workRef;
    this.itemContainer = myContainer;
    this.sundaeInfo = infoRef;

    this.toppingPool = new SpritePool(ToppingSprite, 50, this.scene);

    /** @type {ToppingSprite[]} */
    this.activeToppings = [];
    this.selectTopping(1);
    this.lastStick = this.scene.time.now;
  }

  selectTopping (value) {
    this.currentToppingId = value;
    const itms = [5,5, 1, 1, 1];
    this.currentToppingTypeCount = itms[value - 1];
  }

  moreToppings (x,y) {
    if (this.currentToppingId === 4) {
      this.addCherry(x,y,0);
      return;
    }
    let count = 13;
    if (this.currentToppingId === 5 || this.currentToppingId === 3) {
      count = 5;
    }
    // eslint-disable-next-line no-param-reassign
    y = -200;
    const vx = 280;
    const vy = 280;

    const ox = 0;
    const oy = 160;

    let tx; let ty;
    let startOffsetX = 0;
    const ltMin = 130;
    const ltMax = 200;

    for (let i = 0; i < count; i++) {
      tx = (Math.random() - 0.5) * vx + ox;
      ty = Math.random() * vy + oy;

      /** @type {ToppingSprite} */
      const s = this.toppingPool.getSprite();
      if (s === null) return;
      const lt = Phaser.Math.Between(ltMin,ltMax) / 100;
      const sid = this.currentToppingId;
      const sid2 = Phaser.Math.Between(1, this.currentToppingTypeCount);
      if (startOffsetX > 0) startOffsetX = 0;
      s.reset(x + startOffsetX,y,tx,ty,lt, sid, sid2);
      s.toppingValue = this.currentToppingId;
      this.activeToppings.push(s);
      this.workRef.toppingThrowContainer.add(s);
    }
    if (this.currentToppingId === 1 || this.currentToppingId === 2) {
      const r = Phaser.Math.Between(1,3);
      ABCyaPhaser.Audio.playOneShot(`sprinkle${r}`, this.scene);
    }
    else if (this.currentToppingId === 3) {
      ABCyaPhaser.Audio.playOneShot(SoundAssetKeys._slide, this.scene);
    }
    else {
      ABCyaPhaser.Audio.playOneShot(SoundAssetKeys._throw, this.scene);
    }
  }

  addCherry (x,clickY) {
    const count = 1;
    const y = -200;
    const vx = 0;
    const vy = 600;

    const ltMin = 1130;
    const ltMax = 1200;

    for (let i = 0; i < count; i++) {
      /** @type {ToppingSprite} */
      const s = this.toppingPool.getSprite();
      if (s === null) return;
      const lt = Phaser.Math.Between(ltMin,ltMax) / 100;
      const sid = this.currentToppingId;
      const sid2 = Phaser.Math.Between(1, this.currentToppingTypeCount);
      const pt = this.workRef.toppingThrowContainer.getLocalPoint(x,clickY);
      s.reset(pt.x,y,vx,vy,lt, sid, sid2, pt.y);
      s.toppingValue = this.currentToppingId;
      this.activeToppings.push(s);
      this.workRef.toppingThrowContainer.add(s);
    }

    ABCyaPhaser.Audio.playOneShot(SoundAssetKeys._cherry_fall, this.scene);
  }

  returnTopping (i) {
    const s = this.activeToppings[i];

    const col = checkPixelCollisionCanvas(s,{ image: this.workRef.tmpImg, canvas: this.workRef.tmpCanvas });
    if (col) {
      const sticky = ABCyaPhaser.Images.addImage(s.x,s.y - this.workRef.sundaePosition.yOffset,s.frame.name, this.scene);

      sticky.scale = s.scale;
      sticky.angle = s.angle;
      sticky.toppingValue = s.toppingValue;
      this.workRef.addToppingToTopScoop(sticky);
      if (sticky.toppingValue === 4) {
        ABCyaPhaser.Audio.playOneShot(SoundAssetKeys._cherry_land, this.scene);
      }
      else if (sticky.toppingValue === 3 || sticky.toppingValue === 5) {
        const dif = this.scene.time.now - this.lastStick;
        if (dif > 75) {
          ABCyaPhaser.Audio.playOneShot(SoundAssetKeys._topping_land, this.scene);
          this.lastStick = this.scene.time.now;
        }
      }
    }

    this.workRef.toppingThrowContainer.remove(s);
    this.scene.children.remove(s);
    this.toppingPool.returnSprite(s);
    this.activeToppings.splice(i,1);
  }

  update (dt) {
    const len = this.activeToppings.length - 1;
    let alive = false;
    for (let i = len; i >= 0; i--) {
      alive = this.activeToppings[i].tick(dt);
      if (alive === false) {
        this.returnTopping(i);
      }
      else {
        this.activeToppings[i].update();
      }
    }
  }
}